import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';
import { Server } from '@wajeez-web/core/api-base';

import {
  createPublisherAsync,
  getPublisherByIdAsync,
  getPublishersLookupsAsync,
  editPublisherAsync,
  setContentEntityPublisherAsync,
} from './slices';
import { PublisherActions } from '.';

export const getPublishersLookups = async (
  searchString?: string,
  onSuccess?: (res: Server.PublisherDashboardOutput[]) => void | Promise<void>
) => {
  const res = await store.dispatch(getPublishersLookupsAsync(searchString));

  return handleDispatchResult(res, onSuccess);
};

export const getPublisherById = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getPublisherByIdAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const createPublisher = async (
  body: Server.AddPublisherCommand,
  onSuccess?: (res: number) => void | Promise<void>
) => {
  const res = await store.dispatch(createPublisherAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const editPublisher = async (
  body: Server.EditPublisherCommand,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(editPublisherAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const setContentEntityPublisher = async (
  body: Server.SetPublisherForContentEntityCommand,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(setContentEntityPublisherAsync(body));

  return handleDispatchResult(res, onSuccess);
};

export const clearPublisherById = async () => {
  store.dispatch(PublisherActions.clearPublisherById());
};
